import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { of, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen, tap } from 'rxjs/operators';
import { DeviceUUID } from 'device-uuid';
import { AuthUtil } from './auth.utils';

export const ahttpHeaders = (token?: string) => {
  const header = new HttpHeaders().set('Content-Type', 'application/json');

  if (token) {
    header.append('Authorization', `Bearer ${token}`);
  }
  return { headers: header };
};

export const buildHttpHeaders = (request: HttpRequest<any>, authUtil: AuthUtil): HttpRequest<any> => {
  const accessToken = authUtil.getAccessToken();
  const tenant = authUtil.getTenant();
  const refreshToken = authUtil.getRefreshToken();
  const deviceId = new DeviceUUID().get();

  request = request.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`,
      'x-tenant-id': tenant,
      'refreshtoken': refreshToken,
      'x-device-id': deviceId
    },
  });
  request = request.body instanceof FormData ? request.clone({ headers: request.headers.set('mimeType', 'multipart/form-data') }) : request.clone({ headers: request.headers.set('Content-Type', 'application/json; charset=utf-8') });

  return request
}

export const retryAfterDelay = (retryMaxAttempts: number, retryDelay: number): any => {
  return retryWhen(errors => {
    return errors.pipe(
      mergeMap((err, count) => {
        if (count === retryMaxAttempts) {
          return throwError(err);
        }
        return of(err).pipe(
          tap(error => console.log(`Retrying ${error.url}. Retry count ${count + 1}`)),
          mergeMap(() => timer(retryDelay))
        );
      })
    );
  });
}
